<template>
    <div>
        <HeaderSection icon="fas fa-align-justify" title="Formularios">
            <template slot="buttons">
                <el-button
                    size="medium"
                    type="danger"
                    icon="el-icon-arrow-left"
                    @click="$router.push('/administracion')">
                    Regresar
                </el-button>
            </template>
        </HeaderSection>
        <el-row :gutter="20">
            <el-form :model="fieldsForm" ref="fieldsForm" label-width="100px" label-position="top"
                     class="demo-ruleForm">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Categoría" prop="cat_category_id"
                                      :rules="{ required: true, message: 'El campo es requerido', trigger: 'change' }">

                            <el-select v-model="fieldsForm.cat_category_id"
                                       @change="filterProcedures(fieldsForm.cat_category_id)"
                                       filterable
                                       style="width:100%;" placeholder="Seleccionar">
                                <el-option
                                    v-for="item in categories"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Trámite" prop="cat_procedure_id"
                                      :rules="{ required: true, message: 'El campo es requerido', trigger: 'change' }">

                            <el-select v-model="fieldsForm.cat_procedure_id"
                                       @change="getElements(fieldsForm.cat_procedure_id)"
                                       filterable
                                       style="width:100%;" placeholder="Seleccionar">
                                <el-option
                                    v-for="item in customProcedures"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <br>
                <div style="float: right; padding: 0px 0" type="text">
                    <el-button type="primary" size="small" icon="el-icon-plus"
                               :disabled="!fieldsForm.cat_procedure_id"
                               @click="addElement">
                        Agregar Elemento
                    </el-button>
                </div>
                <br>
                <br>
                <el-row :gutter="20" v-if="fieldsForm.cat_procedure_id">
                    <el-col :span="24">

                        <el-card class="box-card">
                            <vue-content-loading :width="300" :height="200" v-if="loading">
                                <rect x="5" y="10" rx="4" ry="4" width="200" height="15"/>
                                <rect x="5" y="30" rx="4" ry="4" width="120" height="10"/>
                                <rect x="5" y="50" rx="4" ry="4" width="100" height="15"/>
                                <rect x="5" y="70" rx="4" ry="4" width="90" height="10"/>
                            </vue-content-loading>
                            <div slot="header" class="clearfix" style="padding: 20px" v-if="!this.notElements">
                                <h4>Vista Previa de elementos</h4>
                                <el-row :gutter="10">
                                    <el-col :span="12">
                                        <i class="fas fa-arrows-alt-v"></i> <small style="color: #0C231E"> Arrestre los
                                        elementos
                                        para determinar el orden de aparición.</small>
                                    </el-col>
                                    <el-col :span="12" v-if="showSearchable">
                                        <i class="el-icon-search"></i> <small
                                        style="color: #0C231E; word-break: break-word !important;">Este formulario
                                        cuenta con al menos un elemento como parámetro para búsquedas.
                                        <br>
                                        Al momento de ingresar solicitudes, se generará una búsqueda autómatica.
                                    </small>
                                    </el-col>
                                </el-row>
                            </div>
                            <div class="fields" style="padding: 10px;border: 1px solid #ebeef5;"
                                 v-if="fieldsForm.fields && fieldsForm.fields.length >0">
                                <draggable :list="fieldsForm.fields" v-if="fieldsForm.fields.length>0" class="dragArea">
                                    <el-row :gutter="20" v-for="(field,index) in fieldsForm.fields" :key="index"
                                            style="border: 2px dotted rgb(235, 238, 245);padding:5px;margin:5px">
                                        <el-col :span="8">
                                            <el-form-item
                                                :class="
											              [
                                                                field.isActive == false ?  'tip-red' : '',
											              ]">
                                                <label class="el-form-item__label">
                                                    <span v-if="field.required" style="color: red">*</span>
                                                    {{field.label}}
                                                </label>

                                                <el-input v-if="field.form_field_type_id == '1'"
                                                          v-my-only-alphanumeric="{maxChars: 70}"
                                                          placeholder="Escribe" :disabled="true"></el-input>
                                                <el-input v-if="field.form_field_type_id == '2' "
                                                          v-my-only-alphanumeric="{maxChars: 70}"
                                                          type="textarea" :disabled="true"
                                                          placeholder="Area de Texto"></el-input>

                                                <el-select
                                                    v-if="field.form_field_type_id == '3' "
                                                    multiple
                                                    style="width:100%;"
                                                    v-model="field[index]"
                                                    placeholder="Seleccione">
                                                    <el-option
                                                        v-for="item in field.options"
                                                        :key="item.id"
                                                        :label="item.name"
                                                        :value="item.id">
                                                    </el-option>
                                                </el-select>

                                                <el-checkbox :disabled="true"
                                                             v-if="field.form_field_type_id == '4' "
                                                             label="Verificación" name="type"></el-checkbox>

                                                <el-select
                                                    v-if="field.form_field_type_id == 5 && field.options && field.options.length > 0 "
                                                    style="width:100%;"
                                                    clearable
                                                    v-model="field.index_field_option_id"
                                                    placeholder="Seleccione">
                                                    <el-option
                                                        v-for="item in field.options"
                                                        :key="item.id"
                                                        :label="item.name"
                                                        :value="item.id">
                                                    </el-option>
                                                </el-select>

                                                <el-date-picker :disabled="true"
                                                                v-if="field.form_field_type_id == '6' "
                                                                type="date" placeholder="Fecha"
                                                                style="width: 100%;"></el-date-picker>

                                                <el-time-picker :disabled="true"
                                                                v-if="field.form_field_type_id == '7' "
                                                                type="fixed-time" placeholder="Pick a time"
                                                                style="width: 100%;"></el-time-picker>
                                                <input :disabled="true"
                                                       v-if="field.form_field_type_id == '8'" type="file"/>

                                                <div v-if="field.form_field_type_id == '9'">
                                                    <h2>{{field.label ?
                                                        field.label : ''}}</h2>
                                                    <hr class="red"/>
                                                </div>

                                                <el-input-number :disabled="true"
                                                                 v-if="field.form_field_type_id == '10'"/>

                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="16" style="padding-top: 10px !important;">
                                            <el-tooltip class="item" effect="dark" content="Eliminar"
                                                        placement="top-end" v-if="!field.id">
                                                <el-button
                                                    size="small"
                                                    icon="el-icon-delete"
                                                    type="danger"
                                                    @click="deleteField(field)"></el-button>
                                            </el-tooltip>
                                            <el-switch
                                                class="label_custom"
                                                v-model="field.isActive"
                                                active-text="Activado"
                                                inactive-color="#13322B"
                                                active-color="#9d2438"
                                                inactive-text="Desactivado">
                                            </el-switch>
                                            <br>
                                            <br>
                                            <el-tooltip class="item" effect="dark" content="Editar"
                                                        placement="top-end">
                                                <el-button
                                                    size="small"
                                                    icon="fal fa-edit"
                                                    type="default"
                                                    @click="editElement(field)">Editar
                                                </el-button>
                                            </el-tooltip>
                                            <br>
                                            <br>
                                            <el-tooltip class="item" effect="dark"
                                                        content="Indexar Elemento" placement="top-end"
                                                        v-if="field.form_field_type_id == '5'">
                                                <el-switch active-color="#13ce66"
                                                           @change="checkOptionsIndexField(field)"
                                                           v-model="field.isIndex">
                                                    Indexar Elemento
                                                </el-switch>
                                            </el-tooltip>
                                            <br>
                                            <br>
                                            <el-tooltip class="item" effect="dark"
                                                        v-if="field.isIndex"
                                                        content="¿A qué elemento desea indexar esta respuesta?"
                                                        placement="top-end">
                                                <el-select
                                                    :clearable="true"
                                                    filterable
                                                    size="small"
                                                    @change="showOptionsIndex(field.index_field)"
                                                    v-model="field.index_field"
                                                    placeholder="¿A que elemento desea indexar este respuesta?">
                                                    <el-option
                                                        v-for="item in indexFields"
                                                        :key="item.id"
                                                        :label="item.label"
                                                        :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </el-tooltip>
                                            <br>
                                            <!--<br>
                                            <el-select
                                                :clearable="true"
                                                filterable
                                                size="small"
                                                v-if="showOptionsToIndex"
                                                v-model="field.index_field_option_id"
                                                placeholder="¿A que opción del catálogo desea indexar este campo ?">
                                                <el-option
                                                    v-for="item in optionsIndex"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                                </el-option>
                                            </el-select>-->
                                        </el-col>
                                    </el-row>
                                </draggable>
                            </div>
                            <label v-if="notElements"
                                   class="el-form-item__label">
                                Sin elementos aún configurados
                            </label>
                        </el-card>
                    </el-col>
                </el-row>
                <br>
                <el-tooltip class="item" effect="dark" content="Guardar cambios"
                            v-if="fieldsForm.fields && fieldsForm.fields.length > 0"
                            placement="top-end">
                    <el-button
                        type="success"
                        size="medium"
                        icon="fal fa-save"
                        align="right"
                        class="buttonFixed"
                        @click="saveUpdateElements" round>
                    </el-button>
                </el-tooltip>
            </el-form>
        </el-row>
        <el-dialog
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            v-if="modalForm"
            title="Elementos"
            class="validate-dialog"
            :visible.sync="showModalFormDialog">

            <el-form label-position="top"
                     label-width="100px"
                     :model="modalForm"
                     ref="modalForm" @submit.native.prevent>
                <el-row type="flex" :gutter="10">
                    <el-col>
                        <el-form-item label="Tipo de campo" prop="form_field_type_id"
                                      :rules="{ required: true, message: 'El campo es requerido', trigger: 'change' }">
                            <el-select v-model="modalForm.form_field_type_id" placeholder="Tipo de campo"
                                       filterable style="width: 100%">
                                <el-option
                                    v-for="item in typeFields"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col v-if="modalForm.form_field_type_id == 3 || modalForm.form_field_type_id == 5">
                        <el-form-item label="Catálogos"
                                      prop="system_catalog_id"
                                      :rules="{ required: true, message: 'El campo es requerido', trigger: 'change' }">

                            <el-select filterable clearable style="width: 100%"
                                       v-model="modalForm.system_catalog_id"
                                       value-key="name"
                                       placeholder="Catálogos">
                                <el-option
                                    v-for="item2 in systemCatalogs"
                                    :key="item2.name"
                                    :label="item2.name"
                                    :value="item2">
                                </el-option>
                            </el-select>

                        </el-form-item>
                    </el-col>
                </el-row>
                <span
                    v-if="modalForm.form_field_type_id != 8 && modalForm.form_field_type_id != 9">
                    <el-row>
                        <el-col :span="24">
                            <el-form-item v-if="modalForm.form_field_type_id != 4">
                                <label class="el-form-item__label">Dato exportable.
                                    <span style="font-size: 6pt !important; color: #009900">Se mostrará en la configuración de plantillas</span>
                                </label>
                                <br>
                                <el-switch
                                    v-model="modalForm.isExportable"
                                    active-text="Sí"
                                    inactive-color="#13322B"
                                    active-color="#9d2438"
                                    inactive-text="No">
                                </el-switch>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24" v-if="modalForm.form_field_type_id != 4">
                            <el-form-item>
                            <label class="el-form-item__label">Obejtivo para búsquedas.
                                <span
                                    style="font-size: 6pt !important; color: #009900; word-break: break-word !important;">
                                    Este elemento será considerado en la búsqueda para ingreso de solicitudes
                                </span>
                            </label>
                            <br>
                            <el-switch
                                v-model="modalForm.isSearchable"
                                active-text="Sí"
                                inactive-color="#13322B"
                                active-color="#9d2438"
                                inactive-text="No">
                            </el-switch>
                        </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item>
                            <label class="el-form-item__label">Visible internamente.
                                <span
                                    style="font-size: 6pt !important; color: #009900; word-break: break-word !important;">
                                    Este elemento sólo será visble internamente y no se mostrará en los formularios de registro
                                </span>
                            </label>
                            <br>
                            <el-switch
                                v-model="modalForm.isPublic"
                                active-text="Sí"
                                inactive-color="#13322B"
                                active-color="#9d2438"
                                inactive-text="No">
                            </el-switch>
                        </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item>
                            <label class="el-form-item__label">Campo bloqueado.
                                <span
                                    style="font-size: 6pt !important; color: #009900; word-break: break-word !important;">
                                    Este elemento se mostrará bloqueado.
                                </span>
                            </label>
                            <br>
                            <el-switch
                                v-model="modalForm.isDisabled"
                                active-text="Sí"
                                inactive-color="#13322B"
                                active-color="#9d2438"
                                inactive-text="No">
                            </el-switch>
                        </el-form-item>
                        </el-col>
                    </el-row>
                </span>

                <el-row
                    v-if="modalForm.form_field_type_id == 1 || modalForm.form_field_type_id == 2 || modalForm.form_field_type_id == 10">
                    <el-col :span="12">
                        <el-form-item
                            :label="modalForm.form_field_type_id != 10 ? 'Mínimo de caracteres' : 'Valor mínimo'">
                            <el-input-number
                                :min="0"
                                v-model="modalForm.minLength">
                            </el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            :label="modalForm.form_field_type_id != 10 ? 'Máximo de caracteres' : 'Valor máximo'">
                            <el-input-number
                                :min="modalForm.minLength"
                                v-model="modalForm.maxLength">
                            </el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-form-item label="Nombre de la etiqueta" prop="label"
                                  :rules="{ required: true, message: 'El campo es requerido', trigger: 'change' }">
                        <el-input v-my-only-alphanumeric="{maxChars: 70}" v-model="modalForm.label"></el-input>
                    </el-form-item>
                </el-row>

                <el-row v-if="modalForm.form_field_type_id != 9">
                    <el-form-item
                        :label="'El campo es requerido'">
                        <el-switch v-model="modalForm.required" active-color="#13ce66"></el-switch>
                    </el-form-item>
                </el-row>
                <br>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-button
                            type="success"
                            icon="el-icon-check"
                            @click="saveElement('modalForm')">
                            {{ modalForm.id=='' ? 'Añadir':'Actualizar'}}
                        </el-button>
                        <el-button type="danger"
                                   icon="el-icon-close"
                                   @click="showModalFormDialog  = false">
                            Cancelar
                        </el-button>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>

    </div>
</template>

<script>
    import HeaderSection from '@/components/partials/HeaderSection';
    import VueContentLoading from "vue-content-loading";
    import draggable from 'vuedraggable';
    import { Loading } from 'element-ui';

    export default {
        components: {
            HeaderSection,
            VueContentLoading,
            draggable,
        },
        created() {
            this.init();
        },

        data() {
            return {
                fieldsForm: {
                    fields: []
                },
                categories: [],
                procedures: [],
                typePeople: [],
                optionsIndexField: [],
                typeFields: [],
                customProcedures: [],
                indexFields: [],
                optionsIndex: [],
                loading: false,
                notElements: false,
                showOptionsToIndex: false,
                modalForm: {
                    index: '',
                    id: '',
                    label: '',
                    required: true,
                    form_field_type_id: '',
                    catalog_id: null,
                    active_clause_id: null,
                    catalog_clause_id: null,
                    office_filter: null,
                    isExportable: null,
                    isDisabled: null,
                    isPublic: null,
                    groups: [],
                    offices: []

                },
                showModalFormDialog: false,
                showSearchable: false,
                catalogCustom: [],
                statistic: [
                    {
                        id: 1,
                        name: 'Sí'
                    },
                    {
                        id: 0,
                        name: 'No'
                    }
                ],
            }
        },

        methods: {
            gotToBack() {

            },

            filterProcedures(category) {
                this.customProcedures = this.procedures.filter(up => up.cat_category_id == category);
            },
            isObject(value) {
                return value && typeof value === 'object' && value.constructor === Object;
            },
            checkField(field) {

                if (this.isObject(field)) {
                    if (field.system_catalog_id != null) {
                        return true;
                    }
                    return false;
                }
                return false;
            },
            init() {
                axios.get('/api/catalogs-forms').then(response => {
                    if (response.data.success) {
                        this.categories = response.data.catalogs.categories;
                        this.procedures = response.data.catalogs.procedures;
                        this.typePeople = response.data.catalogs.typePeople;
                        this.systemCatalogs = response.data.catalogs.systemCatalogs;
                    }
                })
            },
            getElements(procedure) {
                if (procedure) {
                    this.notElements = false;
                    this.fieldsForm.fields = [];
                    this.loading = true;
                    axios.get('/api/get-elements', {params: {cat_procedure_id: procedure}}).then(response => {
                        if (response.data.success) {
                            response.data.elements ? this.fieldsForm.fields = response.data.elements : this.notElements = true;
                            this.typeFields = response.data.typeFields;
                            if (this.fieldsForm.fields.length > 0) {
                                let _filterSearchable = this.fieldsForm.fields.filter(up => up.isSearchable == true)
                                _filterSearchable.length > 0 ? this.showSearchable = true : this.showSearchable = false
                            }

                        } else {
                            this.$store.dispatch('notifications/error', {msg: response.data.message}, {root: true});
                        }
                        this.loading = false;
                    })
                }
            },

            deleteField() {

            },

            editElement(field) {

                let index = this.fieldsForm.fields.indexOf(field);
                let system_catalog_id = null;
                if (field.system_catalog_id) {
                    let _name = this.systemCatalogs.filter(up => up.id == field.system_catalog_id);
                    system_catalog_id = {
                        id: field.system_catalog_id,
                        name: _name[0].name
                    };
                }

                this.modalForm = {
                    index: index,
                    id: field.id,
                    label: field.label,
                    required: field.required,
                    form_field_type_id: field.form_field_type_id,
                    options: field.options,
                    system_catalog_id,
                    isSearchable: field.isSearchable,
                    isTarget: field.isTarget,
                    isExportable: field.isExportable,
                    isPublic: field.isPublic,
                    isDisabled: field.isDisabled,
                    maxLength: field.maxLength,
                    minLength: field.minLength,

                };

                this.showModalFormDialog = true;

            },

            checkOptionsIndexField(field) {
                if (field.index_field_option_id) {
                    this.indexFields = this.fieldsForm.fields.filter(up => up.form_field_type_id != 9 && up.id != field.id);

                } else {
                    this.$store.dispatch('notifications/warning', {msg: 'Primero seleccione una opción del catálogo'}, {root: true});
                    return field.isIndex = false;
                }

            },

            showOptionsIndex(field) {
                if (field) {
                    let _search = this.fieldsForm.fields.filter(up => up.id == field);
                    _search = _.head(_search);
                    if (_search.field_type_id == 5) {
                        this.optionsIndex = _search.options;
                        this.showOptionsToIndex = true
                    }
                }

            },

            addElement() {

                this.modalForm = {
                    index: '',
                    id: '',
                    label: '',
                    required: true,
                };
                this.showModalFormDialog = true;


            },

            saveElement(ref) {
                this.$refs[ref].validate((valid) => {
                    if (valid) {
                        let _data = this.modalForm;
                        _data.cat_procedure_id = this.fieldsForm.cat_procedure_id;
                        _data.order = this.modalForm.index;
                        this.loading = true;
                        let loadingInstance = Loading.service({
                            lock: true,
                            text: 'Procesando información, espere...',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });
                        axios.post('/api/elements', _data).then(response => {
                            if (response.data.success) {
                                this.$store.dispatch('notifications/ok', {msg: response.data.message}, {root: true});
                                this.fieldsForm.fields = [];
                                this.fieldsForm.fields = response.data.elements;
                                this.showModalFormDialog = false;
                                this.notElements = false;
                                loadingInstance.close();
                            } else {
                                this.$store.dispatch('notifications/info', {msg: response.data.message}, {root: true});
                                loadingInstance.close();
                            }
                            this.loading = false;
                            loadingInstance.close();
                        }).catch(error => {
                            console.log('createNewField', error);
                            this.loading = false;
                            loadingInstance.close();

                            this.$notify({
                                type: 'error',
                                title: 'Error',
                                message: 'Error al crear, intente nuevamente.'
                            });
                        });
                    }
                });

            },

            saveUpdateElements() {

                this.$confirm('Verifique que el orden y la información capturada en cada elemento sea correcta.', 'Atención', {
                    confirmButtonText: 'Continuar',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'
                }).then(() => {
                    this.loading = true;
                    this.fieldsForm.fields.forEach((item, index) => {
                        item.order = index;
                    });
                    let loadingInstance = Loading.service({
                        lock: true,
                        text: 'Procesando información, espere...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    axios.post('/api/save-elements', this.fieldsForm).then(response => {
                        if (response.data.success) {
                            this.$store.dispatch('notifications/ok', {msg: response.data.message}, {root: true});
                            loadingInstance.close();
                        } else {
                            this.$store.dispatch('notifications/error', {msg: response.data.message}, {root: true});
                            loadingInstance.close();
                        }
                        this.loading = false;
                    }).catch(error => {
                        console.log('saveUpdateElements', error);
                        loadingInstance.close();
                        this.$notify({
                            type: 'error',
                            title: 'Error',
                            message: 'Error al guardar'
                        });
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Cancelado'
                    });
                });

            }
        }
    }
</script>

<style scoped>

    .buttonFixed {

        outline: none;
        position: fixed;
        z-index: 99;
        bottom: 2.5em;
        right: 5.5em;
        /*top: 50.0em;*/
        border-radius: 30px;
        font-size: 15px;
        padding: 10px 15px 10px 15px;
        border-radius: 45px;
        background-color: #087a4b;
        background-image: radial-gradient(circle farthest-corner at 100% 0, #00B233, transparent);
        border: 1px solid #dcdfe6;
        color: #fff;
    }

    .buttonFixed:hover {
        cursor: pointer;
        background-color: #3d9671;
        background-image: radial-gradient(circle farthest-corner at 100% 0, #00B233, transparent);
    }

    .buttonFixed:active,
    .buttonFixed:visited,
    .buttonFixed:link {
        background-color: #087a4b;
        background-image: radial-gradient(circle farthest-corner at 100% 0, #00B233, transparent);
    }


    hr.red {
        border-top-color: rgb(220, 224, 224);
        margin: 10px 0px 70px;
    }

    hr.red {
        border-top-color: rgb(220, 224, 224);
        margin: 10px 0px 70px;
    }

    hr.red {
        border-top-color: rgb(220, 224, 224);
        margin: 10px 0px 70px;
    }

    hr.red {
        border-top-color: rgb(220, 224, 224);
        margin: 10px 0px 70px;
    }

    .red {
        color: rgb(162, 34, 68);
    }

    .red {
        color: rgb(162, 34, 68);
    }

    .red {
        color: rgb(162, 34, 68);
    }

    .red {
        color: rgb(162, 34, 68);
    }

    hr {
        margin-top: 25px;
        margin-bottom: 25px;
        border-top: 1px solid rgb(238, 238, 238);
    }

    hr {
        box-sizing: content-box;
        height: 0px;
    }

    hr, img {
        border-width: 0px;
        border-style: initial;
        border-color: initial;
        border-image: initial;
    }

    hr {
        margin-top: 25px;
        margin-bottom: 25px;
        border-top: 1px solid rgb(238, 238, 238);
    }

    hr {
        box-sizing: content-box;
        height: 0px;
    }

    hr, img {
        border-width: 0px;
        border-style: initial;
        border-color: initial;
        border-image: initial;
    }

    hr {
        margin-top: 25px;
        margin-bottom: 25px;
        border-top: 1px solid rgb(238, 238, 238);
    }

    hr {
        box-sizing: content-box;
        height: 0px;
    }

    hr, img {
        border-width: 0px;
        border-style: initial;
        border-color: initial;
        border-image: initial;
    }

    hr {
        margin-top: 25px;
        margin-bottom: 25px;
        border-top: 1px solid rgb(238, 238, 238);
    }

    hr {
        box-sizing: content-box;
        height: 0px;
    }

    hr, img {
        border-width: 0px;
        border-style: initial;
        border-color: initial;
        border-image: initial;
    }

    hr {
        box-sizing: content-box;
        height: 0;
        overflow: visible;
    }

    *, ::after, ::before {
        box-sizing: border-box;
    }

    *, ::after, ::before {
        box-sizing: border-box;
    }

    *, ::after, ::before {
        box-sizing: border-box;
    }

    *, ::after, ::before {
        box-sizing: border-box;
    }

    hr {
        display: block;
        unicode-bidi: isolate;
        margin-block-start: 0.5em;
        margin-block-end: 0.5em;
        margin-inline-start: auto;
        margin-inline-end: auto;
        overflow: hidden;
        border-style: inset;
        border-width: 1px;
    }


    hr.red::before {
        width: 35px;
        height: 5px;
        background-color: rgb(179, 142, 93);
        position: absolute;
    }

    .box.inverted::before, hr.red::before {
        content: " ";
    }

    .box a, hr.red::before {
        display: block;
    }

    hr.red::before {
        width: 35px;
        height: 5px;
        background-color: rgb(179, 142, 93);
        position: absolute;
    }

    .box.inverted::before, hr.red::before {
        content: " ";
    }

    .box a, hr.red::before {
        display: block;
    }

    hr.red::before {
        width: 35px;
        height: 5px;
        background-color: rgb(179, 142, 93);
        position: absolute;
    }

    .box.inverted::before, hr.red::before {
        content: " ";
    }

    .box a, hr.red::before {
        display: block;
    }

    hr.red::before {
        width: 35px;
        height: 5px;
        background-color: rgb(179, 142, 93);
        position: absolute;
    }

    .box.inverted::before, hr.red::before {
        content: " ";
    }

    .box a, hr.red::before {
        display: block;
    }

    *, ::after, ::before {
        box-sizing: border-box;
    }

    *, ::after, ::before {
        box-sizing: border-box;
    }

    *, ::after, ::before {
        box-sizing: border-box;
    }

    *, ::after, ::before {
        box-sizing: border-box;
    }

    *, ::after, ::before {
        box-sizing: border-box;
    }

    *, ::after, ::before {
        box-sizing: border-box;
    }

    *, ::after, ::before {
        box-sizing: border-box;
    }

    *, ::after, ::before {
        box-sizing: border-box;
    }

    .label_custom > el-switch__label {
        font-size: 6pt !important;
    }
</style>
